import { alertMessages, mutationActions, scriptEditorModel } from '../app-root';
import { VerbatimActions } from '@masala-lib/editorial/models/actions/verbatim-actions';

export class ScriptEditorVerbatimActions extends VerbatimActions {
  get mutationActions() {
    return mutationActions;
  }
  get content() {
    return scriptEditorModel.elements;
  }
  get alertMessages() {
    return alertMessages;
  }
}
